<div class="page-header">
    <h2 id="{{addressHeader}}">{{addressHeader}}</h2>
</div>
<div class="row form-group" *ngIf="lineOfBusiness != 'Commercial Property'">
    <div class="col-sm-7 col-md-7 col-lg-5">
        <label for="{{ fieldNameSpace + 'Country'}}">Country</label>
        <select class="form-control nw-input--medium" name="{{ fieldNameSpace + 'Country'}}" id="{{ fieldNameSpace + 'Country'}}" aria-required="true"
            attr.aria-describedby="{{ fieldNameSpace + 'Country'}}" [formControl]="country" (ngModelChange)="resetLocation() ">
            <option *ngFor="let countryItem of countries" [value]="countryItem">{{countryItem}}</option>
        </select>
    </div>
</div>
<div class="row form-group ">
    <div class="col-sm-7 col-md-7 col-lg-5 ">
        <label for="{{ fieldNameSpace + 'Address'}}">Address</label>
        <input type="text " class="form-control " id="{{ fieldNameSpace + 'Address'}}" name="{{ fieldNameSpace + 'Address'}}" aria-required="true"
            attr.aria-describedby="{{ fieldNameSpace + 'Address'}}" [formControl]="address" [ngClass]="{'has-error':(address.invalid && address.touched)}">
        <span id="{{ fieldNameSpace + 'Address-help'}}" class="help-block ">We'll also accept an intersection, highway or major
            road.</span>
        <div *ngIf="address.invalid && address.touched" class="alert alert-danger nw-field-error" id="addressErrorId">
            <span *ngIf="address.hasError('required')" id="addressErrorMessage">Required</span>
            <span *ngIf="address.hasError('pattern')" id="addressErrorMessage">Address is invalid</span>
        </div>
    </div>
</div>
<div class="row form-group ">
    <div class="col-sm-7 col-md-5 col-lg-5 ">
        <label for="{{ fieldNameSpace + 'City'}}">City</label>
        <input type="text " class="form-control " id="{{ fieldNameSpace + 'City'}}" name="{{ fieldNameSpace + 'City'}}" aria-required="true" [formControl]="city"
            [ngClass]="{'has-error':(city.invalid && city.touched)}">
        <div *ngIf="city.invalid && city.touched" class="alert alert-danger nw-field-error" id="cityErrorId">
            <span *ngIf="city.hasError('required')" id="cityErrorMessage">Required</span>
            <span *ngIf="city.hasError('pattern')" id="cityErrorMessage">City is invalid</span>
        </div>
    </div>
    <div class="col-sm-5 col-md-3 " *ngIf="country.value !='Canada' && country.value !='Puerto Rico' && country.value !='Other'">
        <label for="{{ fieldNameSpace + 'State'}}">State</label>
        <select class="form-control nw-input--medium" name="{{ fieldNameSpace + 'State'}}" id="{{ fieldNameSpace + 'State'}}" aria-required="true" attr.aria-describedby="{{ fieldNameSpace + 'State'}}"
            [formControl]="state" [ngClass]="{'has-error': (state.touched && state.invalid)}">
            <option value="">Select a state</option>
            <option *ngFor="let state of currentStatesList">{{state}}</option>
        </select>
        <div *ngIf="state.touched && state.invalid" class="alert alert-danger nw-field-error" id="stateErrorId">
            <span id="stateErrorMessage">Required</span>
        </div>
    </div>
    <div class="col-sm-5 col-md-3 " *ngIf="country.value==='Canada'">
        <label for="{{ fieldNameSpace + 'Province'}}">Province</label>
        <select class="form-control nw-input--medium " name="{{ fieldNameSpace + 'Province'}}" id="{{ fieldNameSpace + 'Province'}}" aria-required="true"
            attr.aria-describedby="{{ fieldNameSpace + 'Province'}}" [formControl]="province" [ngClass]="{'has-error':( province.touched && province.invalid)}">
            <option value="">Select a Province</option>
            <option *ngFor="let province of provinces">{{province}}</option>
        </select>
        <div *ngIf="province.touched && province.invalid" class="alert alert-danger nw-field-error" id="provinceErrorId">
            <span id="provinceMessage">Required</span>
        </div>
    </div>
    <div class="col-sm-5 col-md-3 " *ngIf="country.value==='Other'">
        <label for="{{ fieldNameSpace + 'OtherStateProvince'}}">State / Province</label>
        <input type="text" class="form-control" id="{{ fieldNameSpace + 'OtherStateProvince'}}" name="{{ fieldNameSpace + 'OtherStateProvince'}}" value="" aria-required="true"
            [formControl]="otherStateProvince" [ngClass]="{'has-error':(otherStateProvince.invalid && otherStateProvince.touched)}">
        <div *ngIf="otherStateProvince.invalid && otherStateProvince.touched" class="alert alert-danger nw-field-error" id="otherStateProvinceErrorId">
            <span *ngIf="otherStateProvince.hasError('required')" id="otherStateProvinceErrorMessage">Required</span>
        </div>
    </div>
</div>
<div class="row form-group" *ngIf="country.value !='Canada' && country.value !='Mexico' && country.value !='Other'">
    <div class="col-sm-4 col-md-3 ">
        <label for="{{ fieldNameSpace + 'Zip'}}">ZIP</label>
        <input type="text " class="form-control" id="{{ fieldNameSpace + 'Zip'}}" name="{{ fieldNameSpace + 'Zip'}}" value="" aria-required="true" [formControl]="zip"
            [ngClass]="{'has-error':(zip.invalid &&  zip.touched)}">
        <div *ngIf="zip.invalid && zip.touched" class="alert alert-danger nw-field-error" id="zipErrorId">
            <span *ngIf="zip.hasError('required')" id="zipErrorMessage">Required</span>
            <span *ngIf="zip.hasError('pattern')" id="zipErrorMessage">ZIP is invalid</span>
        </div>
    </div>
</div>
<div class="row form-group" *ngIf="country.value==='Canada' || country.value==='Mexico' || country.value==='Other'">
    <div class="col-sm-4 col-md-3">
        <label for="{{ fieldNameSpace + 'PostalCode'}}">Postal Code</label>
        <input type="text " class="form-control " id="{{ fieldNameSpace + 'PostalCode'}}" name="{{ fieldNameSpace + 'PostalCode'}}" value="" aria-required="true" [formControl]="postalCode"
            [ngClass]="{'has-error':(postalCode.invalid && postalCode.touched)}">
        <div *ngIf="postalCode.invalid && postalCode.touched" class="alert alert-danger nw-field-error" id="postalCodeErrorId">
            <span *ngIf="postalCode.hasError('required')" id="postalCodeErrorMessage">Required</span>
            <span *ngIf="postalCode.hasError('pattern')" id="postalCodeErrorMessage">Postal Code is invalid</span>
        </div>
    </div>
</div>